export enum Locale {
  arAE = 'ar-AE',
  enGB = 'en-GB',
  enUS = 'en-US',
  esUS = 'es-US',
  fiFI = 'fi-FI',
  frBE = 'fr-BE',
  nbNO = 'nb-NO',
  nlBE = 'nl-BE',
  ptBR = 'pt-BR',
  svSE = 'sv-SE',
  itIT = 'it-IT',
}

export const allLocales = Object.values(Locale);
